<template>
  <v-timeline-item
    :icon-color="iconColor"
    fill-dot
    :icon="icon"
    :color="iconBackground"
    class="iconClass timeline--icon">
    <v-layout justify-space-between>
      <v-flex xs7>
        <component
          v-bind:is="activityMeta.activityComponent"
          :eventDateObj="e"
          :text="activityMeta.text"
          :message="displayMessage"
          :accountId="accountId">
        </component>
        <span class="body-1 opacity-54">{{ caseTypeName }}</span>
      </v-flex>
      <v-flex xs5 text-xs-right class="mt-1">
        <v-btn
          v-if="isCollapsible(e.activity).collapse"
          icon dark
          @click="expandShow = !expandShow"
          class="mr-2 mt-0"
          style="margin-top:-6px !important">
          <v-icon color="primary">{{ expandShow ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</v-icon>
        </v-btn>
        <div class="body-1 opacity-54 timeline-date">{{formatDate(e.createdAt)}}</div>
        <UserAvatar
          v-if="e.causedBy"
          :user-id="e.causedBy.id"
          :name="e.causedBy.displayName"
          :status="e.causedBy.deletedAt === null ? 'active' : 'deleted'"
          avatarOnly
          class="timeline-user-avatar">
        </UserAvatar>
      </v-flex>
    </v-layout>
    <v-slide-y-transition v-if="isCollapsible(e.activity).collapse">
      <v-card-text v-if="expandShow" class="pt-3 px-0">
        <component v-bind:is="activityMeta.detailComponent" :eventDateObj="e"></component>
      </v-card-text>
    </v-slide-y-transition>
  </v-timeline-item>
</template>

<script>
import { lookupByEventType, normaliseEventType } from "@/stores/timeline/eventTypes"
import { mapState } from "vuex"
import TitleWithMessage from "@/components/timeline/event-details/activity/TitleWithMessage"
import SinglePrefixTitle from "@/components/timeline/event-details/activity/SinglePrefixTitle"
import DoublePostTitle from "@/components/timeline/event-details/activity/DoublePostTitle"
import DoublePrefixTitle from "@/components/timeline/event-details/activity/DoublePrefixTitle"
import DocumentActivity from "@/components/timeline/event-details/activity/DocumentActivity"
import BookmarkActivity from "@/components/timeline/event-details/activity/BookmarkActivity"
import StateChange from "@/components/timeline/event-details/StateChange"
import UpdateCase from "@/components/timeline/event-details/UpdateCase"
import Documents from "@/components/timeline/event-details/Documents"
import Notes from "@/components/timeline/event-details/Notes"
import Conversations from "@/components/timeline/event-details/Conversations"
import CustomEvent from "@/components/timeline/event-details/CustomEvent"
import AdminChange from "@/components/timeline/event-details/AdminChange"
import { hasCustomEventDetail } from "@/components/timeline/customEventDetail"
import UserAvatar from "@/components/Users/UserAvatar.vue"
import Helpers from "@/helpers.js"

export default {
  name: "event",
  data: () => {
    return {
      expandIcon: "keyboard_arrow_up",
      expandLabel: "More",
      expandShow: false
    }
  },
  components: {
    TitleWithMessage,
    SinglePrefixTitle,
    DoublePostTitle,
    DoublePrefixTitle,
    DocumentActivity,
    BookmarkActivity,
    UpdateCase,
    StateChange,
    Documents,
    Conversations,
    UserAvatar,
    Notes,
    CustomEvent,
    AdminChange
  },
  props: ["e", "icon", "iconColor", "dateTimeFormat", "iconBackground"],
  methods: {
    isCollapsible: function(rawActivity) {
      const activity = normaliseEventType(rawActivity)
      if (activity === "timeline.custom") {
        if (hasCustomEventDetail(this.e)) {
          return { collapse: true, disabled: false }
        }
        return { collapse: false, disabled: true }
      }
      const meta = lookupByEventType(this.activity, activity) || this.activityMeta
      if (meta) {
        // If document and NOT image
        if (
          activity && activity.includes && activity.includes("document") && this.e.params && this.e.params.contentType && !this.e.params.contentType.includes("image/")
        ) {
          return { collapse: false, disabled: true }
        }
        if (meta.collapseInfo) {
          return { collapse: true, disabled: false }
        }
      }
      return { collapse: false, disabled: true }
    },
    expandEvent: function() {
      this.expandIcon =
        this.expandIcon === "keyboard_arrow_down"
          ? "keyboard_arrow_up"
          : "keyboard_arrow_down"
      this.expandLabel = this.expandLabel === "More" ? "Less" : "More"
      this.expandShow = !this.expandShow
    },
    formatDate: function(theDate) {
      return Helpers.formatDate(theDate, 'h:mma, Do MMM')
    }
  },
  computed: {
    ...mapState({
      activity: state => state.timeline.event_types,
      avatarUrl: state => state.currentUser.me.avatar_url,
      accountId: state => state.currentUser.account.id
    }),
    getAvatarUrl: function() {
      return this.avatarUrl
        ? this.$store.getters.getApiEndPoint + this.avatarUrl
        : "/img/timeline-participant-subtle-icon.svg"
    },
    activityMeta() {
      const meta = lookupByEventType(this.activity, this.e && this.e.activity)
      if (meta) {
        return meta
      }
      return {
        activityComponent: "TitleWithMessage",
        text: "",
        collapseInfo: false,
        detailComponent: null
      }
    },
    displayMessage() {
      const params = this.e && this.e.params
      if (params && params.fullMessage) {
        return params.fullMessage
      }
      return this.e && this.e.message ? this.e.message : ""
    },
    caseTypeName() {
      return this.e && this.e.caseType && this.e.caseType.name ? this.e.caseType.name : ""
    }
  }
}
</script>
<style>
.v-list--two-line .v-list__tile {
  min-height: 72px !important;
  height: auto !important;
}
.expand-info .expand-title {
  color: rgba(0, 0, 0, 0.75) !important;
}
.expand-info {
  background: #f7f7f7 !important;
  width: 100%;
  color: rgba(0, 0, 0, 0.54) !important;
}
.right {
  float: right;
}
.event_type_icon {
  width: 40px;
  height: 40px;
}
.event_avatar_icon,
.event_avatar_icon img {
  width: 35px !important;
  height: 35px !important;
}
.event_user_display {
  margin-top: 15px;
}
/* Is NOT Vuetify specific breakpoint */
@media all and (max-width: 699px) {
  .event_type_icon {
    width: 35px !important;
    height: 35px !important;
  }
  .event_avatar_icon {
    width: 30px !important;
    height: 30px !important;
  }
}
/* Adjusts event padding/margin for "sm" ONLY - Vuetify breakpoints */
@media all and (min-width: 600px) and (max-width: 959px) {
  .event_avatar_icon {
    width: 30px !important;
    height: 30px !important;
  }
}
/* Adjusts event padding/margin for "sm" AND "xs" Vuetify breakpoints */
@media all and (max-width: 959px) {
  .event_user_display {
    font-size: 0.9em;
    margin-top: 5px;
  }
}
.event_datetime_formatted {
  padding-right: 5px;
  text-align: right;
}
.event_user_display {
  padding-right: 5px;
}
.toggle_event_detail {
  text-align: center;
  margin: 0 auto !important;
}
.detail-container {
  background: #f9f9f9;
}
.clear {
  clear: both;
}
</style>
